import type { TSerializedWidget } from 'src/entities/workspace/types';
import { extractAndStashReferenceWellsTree } from 'src/packages/reference-wells-persistence/extract-and-stash-reference-wells-tree';
import { parseWellCorrelationWidgetInternalState } from 'src/pages/dashboard/features/well-correlation-widget/parseWellCorrelationWidget';
import { WellCorrelationWidgetEntity } from 'src/pages/dashboard/features/well-correlation-widget/WellCorrelationWidget.entity';

export function mapWellCorrelationWidget(widget: TSerializedWidget, index: number): WellCorrelationWidgetEntity {
  const stripped = extractAndStashReferenceWellsTree(widget);
  const internalState = parseWellCorrelationWidgetInternalState(stripped.internalState);

  return new WellCorrelationWidgetEntity(
    {
      wellId: internalState.wellId,
      stateParams: internalState.stateParams,
      type: 'well-correlation-widget',
    },
    {
      uuid: stripped.uuid,
      isPinned: !!stripped.isPinned,
      zIndex: index + 1,
      isFullscreen: stripped.isFullscreen ?? false,
      position: {
        x: stripped?.position?.x ?? 0,
        y: stripped?.position?.y ?? 0,
      },
      size: {
        w: stripped.size?.w ?? 200,
        h: stripped.size?.h ?? 200,
      },
      groupId: stripped.groupId,
      isGroupsDefaultOpened: false,
    },
  );
}
